import Contact from '../components/pages/Contact';

export default Contact;
